module.exports = __webpack_public_path__ + "media/images/user-3a34d8d94d163221495e9acc2281e3e4.svg";